import { render, staticRenderFns } from "./UpOrDownBoxDialog.vue?vue&type=template&id=189520e2&scoped=true&"
import script from "./UpOrDownBoxDialog.vue?vue&type=script&lang=js&"
export * from "./UpOrDownBoxDialog.vue?vue&type=script&lang=js&"
import style0 from "./UpOrDownBoxDialog.vue?vue&type=style&index=0&id=189520e2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "189520e2",
  null
  
)

export default component.exports